import { named, optional, withDependencies } from '@wix/thunderbolt-ioc'
import {
	Experiments,
	ExperimentsSymbol,
	MasterPageFeatureConfigSymbol,
	SiteFeatureConfigSymbol,
} from '@wix/thunderbolt-symbols'
import { name as tpaCommonsName, TpaCommonsSiteConfig } from 'feature-tpa-commons'
import { IRoutingLinkUtilsAPI, RoutingLinkUtilsAPISymbol } from 'feature-router'
import { LightboxUtilsSymbol, ILightboxUtils } from 'feature-lightbox'
import { IMultilingualLinkUtilsAPI, MultilingualLinkUtilsAPISymbol } from 'feature-multilingual'
import { name } from '../symbols'
import { getSiteMap } from '../utils/siteMap'
import type { DsTpaMasterPageConfig, ISiteMapDs } from '../types'

export const DsSiteMap = withDependencies(
	[
		named(SiteFeatureConfigSymbol, tpaCommonsName),
		named(MasterPageFeatureConfigSymbol, name),
		RoutingLinkUtilsAPISymbol,
		ExperimentsSymbol,
		optional(LightboxUtilsSymbol),
		optional(MultilingualLinkUtilsAPISymbol),
	],
	(
		tpaCommonsSiteConfig: TpaCommonsSiteConfig,
		tapMasterPageConfig: DsTpaMasterPageConfig,
		routingLinkUtilsAPI: IRoutingLinkUtilsAPI,
		experiments: Experiments,
		lightboxUtils: ILightboxUtils,
		multilingualLinkUtilsAPI?: IMultilingualLinkUtilsAPI
	): ISiteMapDs => ({
		getSiteMap: () =>
			getSiteMap(
				tapMasterPageConfig.siteMapItems,
				tpaCommonsSiteConfig,
				routingLinkUtilsAPI,
				lightboxUtils,
				experiments,
				multilingualLinkUtilsAPI
			),
	})
)
